import React from 'react';

const HtmlContent = ({ content }) => {
  if (!content) return null;
  const isReactElement = React.isValidElement(content);
  if(isReactElement) return content;
  return (
    <span dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default HtmlContent;
